'use client';

import React from 'react';
import { AiSkillPublic } from '@ctrl-enter/types/ai-skills';
import { cn } from '../../utils/cn';
import { IconButton, type IconName } from '../icon-button';
import { Tooltip } from '../tooltip';

type SkillSelectorButtonProps = {
  selectedSkill: AiSkillPublic | null | undefined;
  onOpen: () => void;
  disabled?: boolean;
};

export const SkillSelectorButton: React.FC<SkillSelectorButtonProps> = ({
  selectedSkill,
  onOpen,
  disabled,
}) => {
  const isActive = !!selectedSkill;
  const iconName: IconName = (selectedSkill?.icon as IconName | undefined) ?? 'Stethoscope';

  return (
    <Tooltip
      content={isActive ? 'Change AI Specialist' : 'Select AI Specialist'}
      side="top"
      delay={300}
    >
      <IconButton
        aria-label={isActive ? 'Change AI Specialist' : 'Select AI Specialist'}
        variant={isActive ? 'default' : 'ghost'}
        size="sm"
        iconSize="md"
        iconName={iconName}
        onClick={onOpen}
        disabled={disabled}
        className={cn(
          isActive
            ? 'text-primary bg-primary/10 hover:bg-primary/20'
            : 'text-text-secondary hover:bg-bg-neutral-7'
        )}
      />
    </Tooltip>
  );
};
